module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_vm._v("calendar demo")]), _vm._v(" "), _c('calendar-demo')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ce56fda!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/app.vue
// module id = 125
// module chunks = 0